import React, { useState, useEffect } from "react";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";

function MenuTree({
  data = [],
  label = "",
  actions = [], // ✅ instead of onEdit/onDelete
  className = "",
  labelClass = "form-label",
  itemClass = "d-flex align-items-center justify-content-between tree-node",
}) {
  const [menuItems, setMenuItems] = useState(data);
  const [expandedNodes, setExpandedNodes] = useState({});

  useEffect(() => {
    setMenuItems(data || []);
  }, [data]);

  const toggleExpand = (id) => {
    setExpandedNodes((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const renderTree = (items = [], depth = 0) => (
    <ul className="list-unstyled ps-3">
      {items
        .sort((a, b) => a.order - b.order)
        .map((item) => {
          const hasChildren = item.child?.length > 0;
          const isExpanded = expandedNodes[item.id];
          const isChild = depth > 0;

          const combinedItemClass = `${itemClass} ${
            isChild ? "bg-light fw-400" : ""
          }`;

          return (
            <li key={item.id} className="mb-1">
              <div className={combinedItemClass}>
                <div
                  className="d-flex align-items-center gap-2 tree-node-element flex-grow-1"
                  role="button"
                  onClick={() => toggleExpand(item.id)}
                >
                  {hasChildren ? (
                    <span>
                      {isExpanded ? <FiChevronDown /> : <FiChevronRight />}
                    </span>
                  ) : (
                    <span className="me-3 fw-400" />
                  )}
                  <span
                    className={`${isChild ? "fs-4 fw-400" : "fs-4 fw-700"}`}
                  >
                    {item.label}
                  </span>
                </div>

                {/* ✅ Flexible actions */}
                <div className="d-flex gap-2">
                  {actions.map((action, index) => {
                    const hasChildren = item.child?.length > 0;
                    // if (action.title?.toLowerCase() === "dynamicMenu" && hasChildren) {
                    //   return null;
                    // }

                    // ❌ If it's the delete action and this menu has children → skip it
                    // Hide delete + dynamicMenu for parent items
                    if (
                      hasChildren &&
                      (action.title === "Delete" ||
                        action.title === "dynamicMenu")
                    ) {
                      return null;
                    }

                    return action.render ? (
                      // Custom render function for components like ToggleSwitch
                      <div key={index}>{action.render(item)}</div>
                    ) : (
                      // Default icon action
                      <img
                        key={index}
                        src={action.icon}
                        title={action.title}
                        alt={action.title}
                        className="cursor-pointer sbpc-icon-size"
                        onClick={() => action.onClick(item)}
                      />
                    );
                  })}
                </div>
              </div>

              {hasChildren && isExpanded && renderTree(item.child, depth + 1)}
            </li>
          );
        })}
    </ul>
  );

  return (
    <div className={className}>
      {label && <label className={`${labelClass} mb-2 d-block`}>{label}</label>}
      {renderTree(menuItems)}
    </div>
  );
}

export default MenuTree;
